export const MONTH_TRANSLATION_KEYS = [
    'bills.months.january',
    'bills.months.february',
    'bills.months.march',
    'bills.months.april',
    'bills.months.may',
    'bills.months.june',
    'bills.months.july',
    'bills.months.august',
    'bills.months.september',
    'bills.months.october',
    'bills.months.november',
    'bills.months.december',
];
export const EMPTY_TRANSLATION = 'EMPTY';
